document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".custom-meal-builder-hero").forEach((container) => {
        const mainSlider = container.querySelector(".custom-meal-builder-hero__swiper");
        const thumbsSlider = container.querySelector(".custom-meal-builder-hero__thumbs-swiper");
        const nextEl = container.querySelector(".swiper-button__next");
        const prevEl = container.querySelector(".swiper-button__prev");

        const swiper2 = new Swiper(thumbsSlider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            allowTouchMove: false,
            on: {
                touchEnd: function(s,e) {
                    let range = 5;
                    let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY
                        - s.touches.startY
                    if (diff < range || diff > -range) s.allowClick = true;
                }
            },
        });

        const swiper = new Swiper(mainSlider, {
            spaceBetween: 0,
            slidesPerView: 1,
            effect: "fade",
            speed: 800,
            navigation: {
                nextEl,
                prevEl,
            },
            thumbs: {
                swiper: swiper2,
            }
        });
    });
});
